import getListenerOptions from "../get-listener-options"

export default {
  init: function() {
    const t = this

    ;[
      "onWinScroll",
      "onWinResize",
      "updateSidebarsObject",
      "applyStyles",
    ].forEach((func) => t[func] = t[func].bind(t))

    t.els = [...document.querySelectorAll(".sticky-sidebar")]

    // window.addEventListener("load", () => t.updateSidebarsObject())
    t.updateSidebarsObject()

    const listenerOptions = getListenerOptions()
    window.addEventListener("scroll", t.onWinScroll, listenerOptions)
    window.addEventListener("resize", t.onWinResize, listenerOptions)
  },

  updateSidebarsObject: function() {
    const t = this

    if (!t.sidebars) {
      t.sidebars = t.els.map((el) => ({
        el,
        parent: el.parentElement,
      }))
    }

    t.sidebars.forEach(({el, parent}, i) => {
      const obj = t.sidebars[i]
      const rectParent = parent.getBoundingClientRect()
      const rectEl = el.getBoundingClientRect()
      obj.parentWidth = rectParent.width
      obj.topOffset = parseInt(window.getComputedStyle(el).getPropertyValue("top"), 10) || 0
      obj.top = rectParent.top + window.scrollY - obj.topOffset
      obj.maxY = rectParent.top + window.scrollY + rectParent.height - rectEl.height - obj.topOffset
    })
  },

  onWinScroll: function() {
    const t = this
    t.sidebars.forEach(t.applyStyles)
  },

  onWinResize: function() {
    const t = this
    t.updateSidebarsObject()
    t.sidebars.forEach((sb, i) => {
      t.applyStyles(sb, i)

      if (sb.isSticky || sb.isAbsolute) {
        sb.el.style.width = `${sb.parentWidth}px`
        sb.fakeEl.style.width = `${sb.parentWidth}px`
      }
    })
  },

  addFakeEl: function(width, el) {
    const f = document.createElement("div")
    f.style.width = `${width}px`
    el.prepend(f)

    return f
  },

  applyStyles: function({
    el,
    parent,
    parentWidth,
    top,
    topOffset,
    maxY,
    isSticky,
  }, i) {
    const t = this
    const sbObj = t.sidebars[i]
    
    const y = document.scrollingElement.scrollTop
    
    if (y > top) {
      if (y < maxY) {
        if (!isSticky) {
          el.classList.add("fixed")
          el.classList.remove("absolute")
          el.style.width = `${parentWidth}px`
          el.style.top = `${topOffset}px`
          !sbObj.fakeEl && (sbObj.fakeEl = t.addFakeEl(parentWidth, parent))
          
          sbObj.isSticky = true
          sbObj.isAbsolute = false
        }
      } else if (isSticky) {
        el.classList.remove("fixed")
        el.classList.add("absolute")
        el.style.top = `${maxY - top}px`
        
        sbObj.isSticky = false
        sbObj.isAbsolute = true
      }
    } else if (isSticky) {
      el.classList.remove("fixed")
      el.style.top = null
      el.style.width = null
      sbObj.fakeEl.remove()
      sbObj.fakeEl = null

      sbObj.isSticky = false
      sbObj.isAbsolute = false
    }
  }
}